import AbstractNode from './AbstractNode';
import {TextSelection} from 'prosemirror-state';
import {goToNextCell, selectedRect, TableMap} from 'prosemirror-tables';
import {addRowAt, createTable, findTable} from '../helper/table';
import {parseJSON, stringifyJSON} from '../../Common/json';
import {decode, encode} from 'html-entities';

export default class Table extends AbstractNode {
    get name() {
        return "table";
    }

    get schema() {
        return {
            attrs: {
              id: {default: null},
              version: {default: null},
              tasks: {default: null},
              filter: {default: null},
              sort: {default: null},
              desc: {default: null},
              size: {default: 10},
            },
            content: "table_row+",
            tableRole: "table",
            isolating: true,
            group: "block",
            parseDOM: [{
              tag: 'table', getAttrs: dom => ({
                id: dom.getAttribute("data-id"),
                version: dom.getAttribute("data-version"),
                tasks: parseJSON(decode(dom.getAttribute("data-tasks"))),
                filter: dom.getAttribute("data-filter"),
                sort: dom.getAttribute("data-sort"),
                desc: dom.getAttribute("data-desc") === '1' ? '1' : null,
                size: Number(dom.getAttribute("data-size") || 10),
              })
            }],
            toDOM: node => [
              'table',
              {
                'class': 'ui celled table compact unstackable',
                'data-id': node.attrs.id,
                'data-version': node.attrs.version ? node.attrs.version : undefined,
                'data-tasks': node.attrs.tasks ? encode(stringifyJSON(node.attrs.tasks)) : undefined,
                'data-filter': node.attrs.filter,
                'data-sort': node.attrs.sort,
                'data-desc': node.attrs.desc,
                'data-size': node.attrs.size,
              },
              0],
        }
    }

    toMarkdown(state, node) {
        const isTaskTable = node.attrs.id && node.attrs.tasks;
        state.flushClose(2);
        state.write('<table class="ui celled table compact stackable"');
        if (isTaskTable) {
          const tableMap = TableMap.get(node);
          state.write(` data-id="${node.attrs.id}" data-version="${node.attrs.version || ''}" data-tasks="${encode(stringifyJSON(node.attrs.tasks))}" data-filter="${encode(stringifyJSON(node.attrs.filter))}" data-sort="${encode(stringifyJSON(node.attrs.sort))}" data-desc="${node.attrs.desc === '1' ? '1' : ''}" data-size="${node.attrs.size}" data-width="${tableMap.width}" data-height="${tableMap.height}"`);
        }
        state.write('>');
        state.ensureNewLine();

        node.forEach((childNode, _, i) => {
          if (isTaskTable) {
            childNode.taskListRow = true;
          }
          state.render(childNode, node, i);
        });

        state.write('</table>');
        state.ensureNewLine();
        state.closeBlock(node);
    }

    get parseMarkdown() {
        return {
            block: "table"
        }
    }

    keys({type}) {
        return {
            Tab: (state, dispatch) => {
                const tableNode = findTable(state.selection);
                if (!tableNode) {
                    return false;
                }

                if (!goToNextCell(1)(state, dispatch)) {
                    dispatch(addRowAt(selectedRect(state).bottom, true)(state.tr));
                }

                return true;
            },
            "Shift-Tab": goToNextCell(-1)
        };
    }

    commands({schema}) {
        return {
            createTable: ({rowsCount, colsCount}) => view => {
                const offset = view.state.tr.selection.anchor + 1;
                const nodes = createTable(schema, rowsCount, colsCount, false);
                const tr = view.state.tr.replaceSelectionWith(nodes).scrollIntoView();
                const resolvedPos = tr.doc.resolve(offset);
                view.dispatch(tr.setSelection(TextSelection.near(resolvedPos)));
            }
        };
    }
}